export default () => {
    return useCookie<number | null>('accessTokenExpiresIn', {
        maxAge: 2592000, // 30 days
        secure: true,
    })
}
